export default __webpack_public_path__ + "media/images/fancybox/fancy_title_left-2bd73956f2fea6c7c459b0e539d615c1.png";